import React from "react";

export default function About() {
  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <h1>
          About <span className="gradient-accent">Tinbox</span>
        </h1>
        <p>Where trust meets efficiency in the world of currency exchange</p>
      </div>

      <div className="page-content">
        <p>
          Welcome to TINBOX (Tinbox Transfers Ltd.), where trust meets
          efficiency in the world of currency exchange. Born out of a deep
          understanding of P2P platforms, we've evolved beyond being active
          merchants to become your trusted ally in the realm of stablecoin
          transactions. No more alerts from your financial institution of fraud
          concerns.
        </p>
        <p>
          Your concerns and experiences with scams and suspicious traders on P2P
          platforms have resonated with us, motivating TINBOX to step up and
          provide a safe, simple, and secure channel for buying and selling
          stablecoins at competitive rates.
        </p>

        <h3>OUR ACTIONS</h3>
        <p>
          Our dedication to your safety goes beyond mere words. Tinbox Transfers
          Ltd. is proud to announce its registration with FINTRAC as a Money
          Services Business (MSB) under the registration number #M23484249. This
          move solidifies our role in detecting, preventing, and deterring money
          laundering, terrorist financing, and other financial crimes.
        </p>
        <p>
          We believe that an informed customer is an empowered one. Before
          delving into any cryptocurrency investment or purchase, we encourage
          you to visit the website by Canadian Department of Financial
          Protection &amp; Innovation (DFPI) for a comprehensive list of known
          crypto-related scams. This extra layer of caution will safeguard your
          hard-earned money and shield you from falling victim to crypto scams.
        </p>
        <p>
          <a href="https://dfpi.ca.gov/crypto-scams/">
            https://dfpi.ca.gov/crypto-scams/
          </a>
        </p>
        <p>
          At TINBOX, we don't just exchange currencies; we build bridges of
          trust. Join us on this journey towards a secure and seamless exchange
          experience.
        </p>
      </div>
    </div>
  );
}
